import { useQuery } from '@tanstack/react-query';
import { getCategories } from '../services/CategoryService';
import type { Category } from '../types/@types/category';

export function useCategories() {
  return useQuery<Category[]>({
    queryKey: ['categories'],
    queryFn: getCategories,
  });
}
